import { render } from "./AccountInfoModal.vue?vue&type=template&id=7e6eba7c&scoped=true"
import script from "./AccountInfoModal.vue?vue&type=script&lang=js"
export * from "./AccountInfoModal.vue?vue&type=script&lang=js"

import "./AccountInfoModal.vue?vue&type=style&index=0&id=7e6eba7c&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6eba7c"]])

export default __exports__